import { Injectable } from '@angular/core';
import { TMGameListTabs } from '@core/enums';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class TriviaMaticManagerService {
  public gameListSelectedMatTab: BehaviorSubject<string> = new BehaviorSubject(TMGameListTabs.games);
  constructor() {}
}
